import React from 'react'
import { Icon } from '../Icon'
import {
  Card,
  CardHeader,
  IconContainer,
  MetricValue,
  MetricLabel,
  MetricHighlight,
  ProgressBar,
  ProgressFill,
} from './AnalysisMainMetricCard.styles'
import { AnalysisMainMetricCardProps } from './AnalysisMainMetricCard.types'

export const AnalysisMainMetricCard: React.FC<AnalysisMainMetricCardProps> = ({
  iconName,
  iconBackgroundColor,
  value,
  label,
  tooltip,
  variant = { type: 'none' },
}) => {
  return (
    <Card>
      <CardHeader>
        <IconContainer $color={iconBackgroundColor}>
          <Icon name={iconName} size="medium" />
        </IconContainer>
      </CardHeader>
      <MetricValue>{value}</MetricValue>
      <MetricLabel>
        {label}
        {tooltip}
      </MetricLabel>
      {variant.type === 'progressBar' && (
        <ProgressBar>
          <ProgressFill
            $percentage={variant.percentage}
            $color={variant.color}
          />
        </ProgressBar>
      )}
      {variant.type === 'highlight' && (
        <MetricHighlight $type={variant.highlightType}>
          {variant.text}
        </MetricHighlight>
      )}
    </Card>
  )
}
